// // const queryString = window.location.search;
// // const urlParams = new URLSearchParams(queryString);
// // let productIds = urlParams.get('products');
// // let quantities = urlParams.get('quantities');

// // if (productIds && quantities) {
// //   productIds = productIds.split(',')
// //   quantities = quantities.split(',')

// //   const items = []

// //   productIds.forEach((value, key) => {
// //     items.push({
// //        id: value,
// //        quantity: quantities[key]
// //     })
// //   })

// //   const payload = {
// //     items
// //   }

// //   jQuery.ajax({
// //     type: "POST",
// //     url: '/cart/clear.js',
// //     data: '',
// //     dataType: 'json',
// //     success: function() {
// //       jQuery.ajax({
// //         type: 'POST',
// //         url: '/cart/add.js',
// //         data: payload,
// //         success: () => {
// //           window.location.href = '/cart/checkout'
// //         }
// //       });
// //     },
// //     error: function(XMLHttpRequest, textStatus) {
// //       /* error code */
// //     }
// //   });
// // }

// (function () {
//   // Prevent double-run
//   if (window.__mergeCartPreparingHandled) return;
//   window.__mergeCartPreparingHandled = true;

//   // Exclusivity list: only one of these may remain if one is requested
//   const ONLY_ONE_OF = [
//     /** Program **/
//     44769583399198, // Metabolic Reboot Program (Inclusive)
//     45306611368222, // Metabolic Reboot Program (Inclusive B) (Warfarin)
//     45276530737438, // Metabolic Reboot Program (Repeat)
//     44769583431966, // Metabolic Reboot Program (Quickstart)
//     49249179631902, // Menopause Masterclass Program

//     /** Addons **/
//     // 44706204516638, // RX Program Profile Blood Test
//     // 44706215854366, // Microbiome Mapping Pathology
//     // 49249434042654, // Women's Health Pathology
//     // 45306624868638, // Your personal supplement regime
//     // 45306624901406, // Your personal supplement regime (Warfarin)

//     // 50035416432926, // Support package

//     /** Fernwood **/
//     49114045481246, // Metabolic Reboot Program (QuickStart)
//   ];

//   // Endpoints (routes fallbacks)
//   const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
//   const updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
//   const cartJsonUrl = '/cart.js';
//   const cartPageUrl = (window.routes && window.routes.cart_url) || '/cart';
//   const checkoutUrl = '/cart/checkout';

//   // Staging page (preparing page) handle
//   const preparingPagePath = '/pages/preparing-cart';

//   // Parse hash as query-like params. Accepts "#!..." or "#..." (lenient)
//   function getHashParams() {
//     const hash = window.location.hash || '';
//     if (!hash) return null;
//     if (!hash.includes('cart=')) return null;
//     let raw = hash.startsWith('#!') ? hash.slice(2) : hash.slice(1);
//     if (raw.startsWith('%21')) raw = raw.slice(3); // handle #%21
//     try { return new URLSearchParams(raw); } catch { return null; }
//   }

//   function clearHash() {
//     try {
//       history.replaceState(null, '', window.location.pathname + window.location.search);
//     } catch (_) {}
//   }

//   function parseItems(listStr) {
//     const items = [];
//     if (!listStr) return items;
//     listStr.split(',').forEach(pair => {
//       const [idStr, qtyStr] = pair.split(':').map(s => s && s.trim());
//       if (!idStr) return;
//       const id = Number(idStr);
//       const qty = Math.max(1, Number(qtyStr || 1));
//       if (Number.isFinite(id) && Number.isFinite(qty)) {
//         items.push({ id, quantity: qty });
//       }
//     });
//     return items;
//   }

//   // Build final destination and forward allowed params
//   function buildFinalRedirectURL(params) {
//     const goToCart = params.get('storefront') === 'true';
//     const base = goToCart ? cartPageUrl : checkoutUrl;

//     const PRESERVE_PARAM_KEYS = [ 'discount', 'note', 'ref', 'payment', 'access_token' ];
//     const PRESERVE_PARAM_PREFIXES = [ 'attributes[', 'checkout[' ];

//     const forwarded = new URLSearchParams();
//     for (const [key, value] of params.entries()) {
//       const lk = key.toLowerCase();
//       if (lk === 'cart' || lk === 'storefront' || lk === 'drawer') continue; // input-only/local-only
//       if (PRESERVE_PARAM_KEYS.includes(lk) || PRESERVE_PARAM_PREFIXES.some(p => lk.startsWith(p))) {
//         forwarded.append(key, value);
//       }
//     }
//     const qs = forwarded.toString();
//     return qs ? `${base}?${qs}` : base;
//   }

//   // If not already on the preparing page, but a cart= hash is present, navigate there preserving hash + search
//   const params = getHashParams();
//   if (params) {
//     const here = window.location.pathname || '/';
//     if (here !== preparingPagePath) {
//       window.location.assign(`${preparingPagePath}${window.location.search || ''}${window.location.hash || ''}`);
//       return;
//     }
//   } else {
//     // No operation needed
//     return;
//   }

//   // On /pages/preparing-cart: perform merge then redirect to final destination
//   (async function run() {
//     const itemsFromLink = parseItems(params.get('cart'));
//     const finalURL = buildFinalRedirectURL(params);

//     // If no items, just forward
//     if (!itemsFromLink.length) {
//       clearHash();
//       window.location.assign(finalURL);
//       return;
//     }

//     try {
//       // Read current cart
//       const cart = await fetch(cartJsonUrl, { method: 'GET', credentials: 'same-origin' }).then(r => r.json());
//       const currentQtyById = {};
//       (cart.items || []).forEach(li => {
//         currentQtyById[li.variant_id] = (currentQtyById[li.variant_id] || 0) + li.quantity;
//       });

//       // Determine which exclusive variant is requested (first wins)
//       const exclusiveInLink = itemsFromLink.find(i => ONLY_ONE_OF.includes(i.id));
//       const selectedExclusiveId = exclusiveInLink ? exclusiveInLink.id : null;

//       // Removals for other exclusives
//       const removals = {};
//       if (selectedExclusiveId) {
//         ONLY_ONE_OF.forEach(vid => {
//           if (vid !== selectedExclusiveId && currentQtyById[vid] > 0) {
//             removals[vid] = 0;
//           }
//         });
//       }

//       // Add only positive deltas, never decrease. Skip non-selected exclusives present in the link
//       const addItems = [];
//       const seen = new Set();
//       for (const it of itemsFromLink) {
//         if (seen.has(it.id)) continue;
//         seen.add(it.id);
//         if (ONLY_ONE_OF.includes(it.id) && selectedExclusiveId && it.id !== selectedExclusiveId) continue;

//         const inCart = currentQtyById[it.id] || 0;
//         const desired = Math.max(inCart, it.quantity);
//         const delta = desired - inCart;
//         if (delta > 0) addItems.push({ id: it.id, quantity: delta });
//       }

//       // 1) Apply removals
//       if (Object.keys(removals).length) {
//         await fetch(updateUrl, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//           body: JSON.stringify({ updates: removals })
//         }).catch(() => {});
//       }

//       // 2) Add deltas
//       if (addItems.length) {
//         await fetch(addUrl, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//           body: JSON.stringify({ items: addItems })
//         }).catch(() => {});
//       }

//       // Done → clear hash and go
//       clearHash();
//       window.location.assign(finalURL);
//     } catch (e) {
//       // Fallback: try blind add then forward
//       try {
//         if (itemsFromLink.length) {
//           await fetch(addUrl, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//             body: JSON.stringify({ items: itemsFromLink })
//           }).catch(() => {});
//         }
//       } finally {
//         clearHash();
//         window.location.assign(finalURL);
//       }
//     }
//   })();
// })();

(function () {
    // Prevent double-run
    if (window.__mergeCartPreparingHandled) return;
    window.__mergeCartPreparingHandled = true;

    // Exclusivity list: only one of these may remain if one is requested
    const ONLY_ONE_OF = [/** Program **/
        44769583399198, // Metabolic Reboot Program (Inclusive)
        45306611368222, // Metabolic Reboot Program (Inclusive B) (Warfarin)
        45276530737438, // Metabolic Reboot Program (Repeat)
        44769583431966, // Metabolic Reboot Program (Quickstart)
        49249179631902, // Menopause Masterclass Program

        /** Addons **/
        // 44706204516638, // RX Program Profile Blood Test
        // 44706215854366, // Microbiome Mapping Pathology
        // 49249434042654, // Women's Health Pathology
        // 45306624868638, // Your personal supplement regime
        // 45306624901406, // Your personal supplement regime (Warfarin)

        // 50035416432926, // Support package

        /** Fernwood **/
        49114045481246, // Metabolic Reboot Program (QuickStart)
    ];

    // Endpoints (routes fallbacks)
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    const updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    const cartJsonUrl = '/cart.js';
    const cartPageUrl = 'https://astonrx.com/collections/all-products';
    const checkoutUrl = '/cart/checkout';

    // Staging page (preparing page) handle
    const preparingPagePath = '/pages/preparing-cart';

    // Parse hash as query-like params. Accepts "#!..." or "#..." (lenient)
    function getHashParams() {
        const hash = window.location.hash || '';
        if (!hash) return null;
        if (!hash.includes('cart=')) return null;
        let raw = hash.startsWith('#!') ? hash.slice(2) : hash.slice(1);
        if (raw.startsWith('%21')) raw = raw.slice(3); // handle #%21
        try {
            return new URLSearchParams(raw);
        } catch {
            return null;
        }
    }

    function clearHash() {
        try {
            history.replaceState(null, '', window.location.pathname + window.location.search);
        } catch (_) {
        }
    }

    function parseItems(listStr) {
        const items = [];
        if (!listStr) return items;
        listStr.split(',').forEach(pair => {
            const [idStr, qtyStr] = pair.split(':').map(s => s && s.trim());
            if (!idStr) return;
            const id = Number(idStr);
            const qty = Math.max(1, Number(qtyStr || 1));
            if (Number.isFinite(id) && Number.isFinite(qty)) {
                items.push({id, quantity: qty});
            }
        });
        return items;
    }

    // NEW: Extract discount + cart attributes from params
    function extractDiscountAndAttributes(params) {
        let discountCode = null;
        let hasDiscount = false;
        const attributes = {};

        for (const [key, value] of params.entries()) {
            const lk = key.toLowerCase();

            if (lk === 'discount') {
                // Discount provided, may be non-empty (apply) or empty (clear)
                hasDiscount = true;
                discountCode = value;
            } else if (lk.startsWith('attributes[') && lk.endsWith(']')) {
                // attributes[free_shopping]=yes
                const start = key.indexOf('[') + 1;
                const end = key.lastIndexOf(']');
                if (start > 0 && end > start) {
                    const attrName = key.slice(start, end);
                    if (attrName) {
                        attributes[attrName] = value;
                    }
                }
            }
        }

        const hasAttributes = Object.keys(attributes).length > 0;

        return {
            hasDiscount, discountCode,          // may be '' to clear discounts
            attributes: hasAttributes ? attributes : null
        };
    }

    // Build final destination and forward allowed params
    function buildFinalRedirectURL(params) {
        // Always go to storefront (all products collection)
        const base = cartPageUrl;

        // Keep these params when redirecting
        const PRESERVE_PARAM_KEYS = ['discount', 'note', 'ref', 'payment', 'access_token'];
        const PRESERVE_PARAM_PREFIXES = ['attributes[', 'checkout['];

        const forwarded = new URLSearchParams();

        for (const [key, value] of params.entries()) {
            const lk = key.toLowerCase();

            // Do not forward these "control" params
            if (lk === 'cart' || lk === 'storefront') continue;

            // Forward whitelisted keys and prefixes
            if (PRESERVE_PARAM_KEYS.includes(lk) || PRESERVE_PARAM_PREFIXES.some(p => lk.startsWith(p))) {
                forwarded.append(key, value);
            }
        }

        const qs = forwarded.toString();
        return qs ? `${base}?${qs}` : base;
    }

    // Ensure drawer=true is present on any redirect URL
    function addDrawerParam(url) {
        try {
            const u = new URL(url, window.location.origin);
            u.searchParams.set('drawer', 'true');
            return u.toString();
        } catch (_) {
            if (url.indexOf('?') === -1) {
                return url + '?drawer=true';
            }
            if (!/[?&]drawer=/.test(url)) {
                return url + '&drawer=true';
            }
            return url;
        }
    }

    // If not already on the preparing page, but a cart= hash is present, navigate there preserving hash + search
    const params = getHashParams();
    if (params) {
        const here = window.location.pathname || '/';
        if (here !== preparingPagePath) {
            window.location.assign(`${preparingPagePath}${window.location.search || ''}${window.location.hash || ''}`);
            return;
        }
    } else {
        // No operation needed
        return;
    }

    // On /pages/preparing-cart: perform merge then redirect to final destination
    (async function run() {
        const itemsFromLink = parseItems(params.get('cart'));
        const finalURL = buildFinalRedirectURL(params);

        // NEW: pull discount + attributes from the hash params
        const {hasDiscount, discountCode, attributes} = extractDiscountAndAttributes(params);

        // If no items, just forward (but still apply discount/attributes if present)
        if (!itemsFromLink.length) {
            try {
                const updatePayload = {};
                if (hasDiscount) updatePayload.discount = discountCode;
                if (attributes) updatePayload.attributes = attributes;

                if (Object.keys(updatePayload).length) {
                    await fetch(updateUrl, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                        body: JSON.stringify(updatePayload)
                    }).catch(() => {
                    });
                }
            } finally {
                clearHash();
                window.location.assign(addDrawerParam(finalURL));
            }
            return;
        }

        try {
            // Read current cart
            const cart = await fetch(cartJsonUrl, {method: 'GET', credentials: 'same-origin'}).then(r => r.json());
            const currentQtyById = {};
            (cart.items || []).forEach(li => {
                currentQtyById[li.variant_id] = (currentQtyById[li.variant_id] || 0) + li.quantity;
            });

            // Determine which exclusive variant is requested (first wins)
            const exclusiveInLink = itemsFromLink.find(i => ONLY_ONE_OF.includes(i.id));
            const selectedExclusiveId = exclusiveInLink ? exclusiveInLink.id : null;

            // Removals for other exclusives
            const removals = {};
            if (selectedExclusiveId) {
                ONLY_ONE_OF.forEach(vid => {
                    if (vid !== selectedExclusiveId && currentQtyById[vid] > 0) {
                        removals[vid] = 0;
                    }
                });
            }

            // Add only positive deltas, never decrease. Skip non-selected exclusives present in the link
            const addItems = [];
            const seen = new Set();
            for (const it of itemsFromLink) {
                if (seen.has(it.id)) continue;
                seen.add(it.id);
                if (ONLY_ONE_OF.includes(it.id) && selectedExclusiveId && it.id !== selectedExclusiveId) continue;

                const inCart = currentQtyById[it.id] || 0;
                const desired = Math.max(inCart, it.quantity);
                const delta = desired - inCart;
                if (delta > 0) addItems.push({id: it.id, quantity: delta});
            }

            // 1) Apply removals + discount + attributes in a single /cart/update.js call
            const updatePayload = {};
            if (Object.keys(removals).length) {
                updatePayload.updates = removals;
            }
            if (hasDiscount) {
                updatePayload.discount = discountCode; // may be '' to clear
            }
            if (attributes) {
                updatePayload.attributes = attributes; // e.g. { free_shopping: 'yes' }
            }

            if (Object.keys(updatePayload).length) {
                await fetch(updateUrl, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                    body: JSON.stringify(updatePayload)
                }).catch(() => {
                });
            }

            // 2) Add deltas
            if (addItems.length) {
                await fetch(addUrl, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                    body: JSON.stringify({items: addItems})
                }).catch(() => {
                });
            }

            // Done → clear hash and go
            clearHash();
            window.location.assign(addDrawerParam(finalURL));
        } catch (e) {
            // Fallback: try blind add + apply discount/attributes, then forward
            try {
                if (itemsFromLink.length) {
                    await fetch(addUrl, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                        body: JSON.stringify({items: itemsFromLink})
                    }).catch(() => {
                    });
                }

                const updatePayload = {};
                if (hasDiscount) updatePayload.discount = discountCode;
                if (attributes) updatePayload.attributes = attributes;

                if (Object.keys(updatePayload).length) {
                    await fetch(updateUrl, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                        body: JSON.stringify(updatePayload)
                    }).catch(() => {
                    });
                }
            } finally {
                clearHash();
                window.location.assign(addDrawerParam(finalURL));
            }
        }
    })();
})();


document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const shouldOpenDrawer = params.get('drawer') === 'true';

    if (!shouldOpenDrawer) return;

    // Try Dawn's cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
    }
});
